
/* Settings
------------------------------------------------------------------------*/

// jQueryObjects
var $doc = $(document),
  $w = $(window),
  $html = $('html'),
  $body,
  $page;

// commonSettings
var lacook = {
  bp_tab : 1024,
  bp_sp : 767,
  pc : '',
  tab : '',
  sp : '',
  pcView : '',
  tabView : '',
  spView : '',
  finish : '',
  deviceWidth : '',
  deviceHeight : '',
  sT : '',
  ie9 : ($html.hasClass('ie9')) ? true : false,
  ua_mouse : ($html.hasClass('mouse')) ? true : false,
  ua_touch : ($html.hasClass('touch')) ? true : false,
  ua_phone : ($html.hasClass('phone')) ? true : false
}


/* Functions & Plugins
------------------------------------------------------------------------*/

// rwdFunctions
var rwdFunctions = {
  // checkValue
  checkValue : function(){
    lacook.deviceWidth = (lacook.ie8) ? $w.width() : window.innerWidth,
    lacook.deviceHeight= $w.height(),
    lacook.pc = (lacook.ie8 || lacook.deviceWidth > lacook.bp_tab) ? true : false,
    lacook.tab = (!lacook.ie8 && lacook.deviceWidth <= lacook.bp_tab && lacook.deviceWidth > lacook.bp_sp) ? true : false,
    lacook.sp = (!lacook.ie8 && lacook.deviceWidth <= lacook.bp_sp) ? true : false;
  },
  // fooLoad
  fooLoad : function($o){
    $o.each(function(){ $(this).attr('src', $(this).data('img')); });
  },
  // loadImg
  loadImg : function(){
    lacook.finish = (lacook.pcView && lacook.tabView && lacook.spView) ? true : false;
    if(!lacook.ie8 && !lacook.finish){
      if(lacook.pc || lacook.tab){
        if(!lacook.pcView || !lacook.tabView){
          rwdFunctions.fooLoad($('img.load_pc-tab'));
        }
        if(lacook.pc && !lacook.pcView){
          rwdFunctions.fooLoad($('img.load_pc'));
          lacook.pcView = true;
        }
        if(lacook.tab && !lacook.tabView){
          rwdFunctions.fooLoad($('img.load_tab-sp'));
          lacook.tabView = true;
        }
      }else if(!lacook.spView){
        rwdFunctions.fooLoad($('img.load_sp,img.load_tab-sp'));
        lacook.spView = true;
      }
    }else if(!lacook.pcView){
      lacook.pcView = true;
    }
  },
  // settingRwd
  settingRwd : function(){
    rwdFunctions.checkValue();
    rwdFunctions.loadImg();
  }
}

// superResize
$.fn.superResize = function(options){
  var defaults = {
    loadAction : true,
    resizeAfter : function(){}
  };
  var setting = $.extend(defaults, options);

  if(setting.loadAction)
    this.load(function(){
      setting.resizeAfter();
    });

  var timer = false,
    w = lacook.deviceWidth;

  this.resize(function(){
    if (timer !== false) clearTimeout(timer);
    timer = setTimeout(function(){
      if(w != lacook.deviceWidth){
        setting.resizeAfter();
        w = lacook.deviceWidth;
      }
    }, 300);
  });
  return(this);
};

// firstLoad
$.fn.firstLoad = function(options){
  var defaults = {
    pc : function(){},
    pc_tab : function(){},
    tab : function(){},
    tab_sp : function(){},
    sp : function(){}
  };
  var setting = $.extend(defaults, options);

  var first = [];

  this.superResize({
    resizeAfter : function(){
      setTimeout(function(){
        if(first[0] != true && lacook.pcView){
          setting.pc();
          first[0] = true;
        }
        if(first[1] != true && lacook.pcView || first[1] != true && lacook.tabView){
          setting.pc_tab();
          first[1] = true;
        }
        if(first[2] != true && lacook.tabView){
          setting.tab();
          first[2] = true;
        }
        if(first[3] != true && lacook.tabView || first[3] != true && lacook.spView){
          setting.tab_sp();
          first[3] = true;
        }
        if(first[4] != true && lacook.spView){
          setting.sp();
          first[4] = true;
        }
      },200);
    }
  });

  return(this);
};

//hasAttr
$.fn.hasAttr = function(name) {
  var attr = this.attr(name);
  if(typeof attr !== 'undefined' && attr !== false)
    return true;
  else
    return false;
}


/* readyEvent
------------------------------------------------------------------------*/

$(function(){

  // Settings ------------------------------//
  $body = $('body'),
  $page = $('#page');

  rwdFunctions.settingRwd();

  // ie8Img ---------------------------------//
  if(lacook.ie8)  rwdFunctions.fooLoad($('img.change_img,img.load_pc,img.load_pc-tab'));

  // telCancel ------------------------------//
  if(!lacook.ua_phone) $('a[href^="tel:"]').wrapInner('<span class="tel"></span>').children('span').unwrap();

  // touching -------------------------------//
  if(lacook.ua_touch){
    $page.find('*').on({
      'touchstart' : function(){
        $(this).addClass('touchstart').removeClass('touchend');
      },
      'touchend' : function(){
        $(this).addClass('touchend').removeClass('touchstart');
      }
    });
  }

  // load & resize & scroll -----------------//
  $w.on({
    'load' : function(){
      $w.trigger('resize').trigger('scroll');
    },
    'resize' : function(){
      rwdFunctions.checkValue();
    },
    'scroll' : function(){
      lacook.sT = $w.scrollTop();
    }
  }).superResize({
    loadAction : false,
    resizeAfter : function(){
      rwdFunctions.settingRwd();
    }
  })

});